// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602090933/js/" + chunkId + "." + {"44":"1eb0b66e","225":"62d3180b","481":"ebdb6dcc","486":"0e560cca","770":"40853c9f"}[chunkId] + ".0.12479636314053244.chunk.js";
};